import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useGameImageUrls } from 'js/hooks/games';
import { useDeviceSelector } from 'js/store/hooks';
import { Image } from 'js/components/common/Image';
import { Button } from 'js/components/common/Button';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './TableItem.scss';

export const TableItem = (props) => {
    const { gameCode: code, player, winAmount, gameName, className, tableItemRef } = props;
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const imageUrls = useGameImageUrls({ code });

    const openGame = useCallback(() => publicEventsAPIService.trigger('game:launch', {
        code,
        mode: 1,
        container: 'top-winners'
    }), [code]);

    return (
        <div ref={tableItemRef} className={`${style.tableContainer} ${className}`}>
            <Image
                alt={gameName}
                src={imageUrls}
                className={style.image}
            />
            {isDesktop
                ? (
                    <>
                        <div className={style.info}>
                            <p className={style.player}>{player}</p>
                            <p className={style.ellipsis}>{gameName}</p>
                        </div>
                        <div className={style.win}>
                            <p className={`${style.justWon} ${style.ellipsis}`}>{translate('justWon')}</p>
                            <p className={style.winAmount}>{winAmount}</p>
                        </div>
                    </>
                )
                : (
                    <div className={style.columnInfo}>
                        <span className={`${style.justWon} ${style.ellipsis}`}>{`${player} ${translate('justWon')}`}</span>
                        <span className={style.winAmount}>{winAmount}</span>
                        <span className={style.ellipsis}>{`${translate('inGame')} ${gameName}`}</span>
                    </div>
                )
            }
            <div className={style.buttonContainer}>
                <Button
                    type="button"
                    onClick={openGame}
                    {...!isDesktop && { size: 'small' }}
                    aria-label={`${translate('play')} ${gameName}`}
                >
                    {translate('play')}
                </Button>
            </div>
        </div>
    );
};
